<template>
  <div class="loader" :class="{ loading, fixed }">
    <div class="inner"><span></span></div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
};
</script>
